import GenericSvgIcon from "@Icons/GenericSvgIcon";
import IconType from "@/types/Icon.type";
import {Colors} from "@Styles/Colors.style";

function IconQuestionsAndAnswers(props: IconType) {
    const {
        width = "56",
        height = "55",
        viewBox = "0 0 56 55",
        fill = "none",
        stroke = Colors.primaryColor,
        ...rest
    } = props

    return (
        <GenericSvgIcon
            {...{width, height, viewBox, ...rest}}
            svgIconPath={(
                <g>
                    <path
                        d="M16.658 17.1159C17.3179 14.0674 18.7124 11.139 20.8626 8.62584C27.6859 0.638387 39.5229 -0.148338 47.2936 6.85571C55.0643 13.8598 56.7036 26.7642 47.3894 35.757L44.5579 46.8913L36.1485 40.4882C32.1461 40.7505 28.0585 39.7124 24.5457 37.3086"
                        stroke={stroke}
                        fill={fill}
                        strokeWidth="3"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M16.4772 18.2748C15.6362 22.0882 17.0839 26.0218 19.7771 26.6447C25.0569 27.8685 27.1113 19.4767 19.9687 17.8268C15.1466 16.7122 10.5374 17.9907 7.34396 20.4055L7.29074 20.4492C4.64019 22.5144 2.77736 25.6394 2.34092 29.2889C1.69159 34.7523 4.40601 39.8333 8.82358 42.3464C10.218 43.1441 11.7828 43.6795 13.4647 43.8871L19.3193 52.7924L23.9817 43.0348"
                        stroke={stroke}
                        fill={fill}
                        strokeWidth="3"
                        strokeLinejoin="round"
                    />
                    <g fill={stroke}>
                        <path
                            d="M30.4536 23.3994C31.2473 23.3994 31.8907 22.739 31.8907 21.9243C31.8907 21.1096 31.2473 20.4492 30.4536 20.4492C29.66 20.4492 29.0166 21.1096 29.0166 21.9243C29.0166 22.739 29.66 23.3994 30.4536 23.3994Z"
                        />
                        <path
                            d="M34.9458 23.3994C35.7395 23.3994 36.3829 22.739 36.3829 21.9243C36.3829 21.1096 35.7395 20.4492 34.9458 20.4492C34.1522 20.4492 33.5088 21.1096 33.5088 21.9243C33.5088 22.739 34.1522 23.3994 34.9458 23.3994Z"
                        />
                        <path
                            d="M39.4378 23.3994C40.2314 23.3994 40.8748 22.739 40.8748 21.9243C40.8748 21.1096 40.2314 20.4492 39.4378 20.4492C38.6441 20.4492 38.0007 21.1096 38.0007 21.9243C38.0007 22.739 38.6441 23.3994 39.4378 23.3994Z"
                        />
                        <path
                            d="M10.4734 33.3308C11.2671 33.3308 11.9105 32.6704 11.9105 31.8557C11.9105 31.041 11.2671 30.3806 10.4734 30.3806C9.67976 30.3806 9.03638 31.041 9.03638 31.8557C9.03638 32.6704 9.67976 33.3308 10.4734 33.3308Z"
                        />
                        <path
                            d="M14.9656 33.3308C15.7593 33.3308 16.4027 32.6704 16.4027 31.8557C16.4027 31.041 15.7593 30.3806 14.9656 30.3806C14.172 30.3806 13.5286 31.041 13.5286 31.8557C13.5286 32.6704 14.172 33.3308 14.9656 33.3308Z"
                        />
                        <path
                            d="M19.4576 33.3308C20.2512 33.3308 20.8946 32.6704 20.8946 31.8557C20.8946 31.041 20.2512 30.3806 19.4576 30.3806C18.6639 30.3806 18.0205 31.041 18.0205 31.8557C18.0205 32.6704 18.6639 33.3308 19.4576 33.3308Z"
                        />
                    </g>
                </g>
            )}
        />
    )
}

export default IconQuestionsAndAnswers